/*
 * @Descripttion: 内容工具接口api
 * @Author: Niu Chenxin
 * @Date: 2021-01-05 13:09:46
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-26 17:09:09
 */
import Http from "./../http";

export default {
  // 获取育儿贴士、孕期贴士
  getParentTipsAllInfo(params, callback) {
    Http.get("/babyCareTips/getAllInfo", params, res => {
      callback(res);
    })
  },
  // 获取宝宝信息
  getBabyInfo(params, callback) {
    Http.get("/starMom/getBaby", params, res => {
      callback(res);
    }, err => {}, "member")
  },
  // 获取测评历史记录
  getHistoryRecord(urlParams, params, callback) {
    Http.post("/growthrecord/historyRecord", urlParams, params, res => {
      callback(res);
    })
  },
  // 获取宝宝月龄
  getTimeWithBirth(urlParams, params, callback) {
    Http.post("/parentingTips/getTimeWithBirth", urlParams, params, res => {
      callback(res);
    })
  },
  // 获取当前宝宝最新一条测评记录
  getArchive(params, callback) {
    Http.get("/growthrecord/newestRecord", params, res => {
      callback(res)
    })
  },
  // 获取所有成长记录
  getAllRecord(params,callback){
    Http.get("/growthrecord/allRecord", params, res => {
        callback(res)
    })
  },
  // 获取生长记录默认数据
  getStandardData(params, callback) {
    Http.get("/growthrecord/standardData", params, res => {
      callback(res)
    })
  },
  // 添加成长记录
  addGrowInfo(urlParams, params, callback) {
    Http.post("/growthrecord/addinfo", urlParams, params, res => {
      callback(res);
    })
  },
  // 获取宝宝日期
  getBabyDays(urlParams, params, callback) {
    Http.post("/parentingTips/getTimeWithBirth", urlParams, params, res => {
      callback(res);
    })
  },
  // 获取宝宝档案
  getBabyArchive(params, callback) {
    Http.get("/babyArchive/getArchive", params, res => {
      callback(res)
    })
  },
  // 获取宝宝测评时实际月龄
  getBirthDay(params, callback) {
    Http.get("/babyCareTips/getTimeWithBirthDay", params, res => {
      callback(res)
    })
  },
}